import React from 'react'

import PropTypes from 'prop-types'

import ComplianceIcon from '../ComplianceIcon'
import { get, filter, includes, toLower, isEmpty } from 'lodash'

const osToExclude = ['mac', 'linux', 'centos', 'ubuntu'];

const AssetRow = ({ asset, falseColor, trueColor }) => {
  const assetSystem = asset.operating_system || asset.machine_type
  const systemSupported = isEmpty(filter(osToExclude, exclude => includes(toLower(assetSystem), toLower(exclude))))
  const tipContent = systemSupported ? null : assetSystem

  return (
    <tr>
      <td>{asset.name}</td>
      <td><ComplianceIcon {...{ boolean: systemSupported ? asset.antivirus_coverage : false, trueColor, falseColor, tipContent }} /></td>
      <td><ComplianceIcon {...{ boolean: asset.monitoring_coverage, trueColor, falseColor }} /></td>
      <td><ComplianceIcon {...{ boolean: systemSupported ? asset.patching_coverage : false, trueColor, falseColor, tipContent }} /></td>
      <td><ComplianceIcon {...{ boolean: asset.data_protection_coverage, trueColor, falseColor }} /></td>
    </tr>
  )
}

AssetRow.propTypes = {
  asset: PropTypes.shape({
    name: PropTypes.string,
    use_default_rules: PropTypes.bool,
    antivirus_coverage: PropTypes.string,
    monitoring_coverage: PropTypes.string,
    patching_coverage: PropTypes.string,
    data_protection_coverage: PropTypes.string
  }).isRequired,
  falseColor: PropTypes.string.isRequired,
  trueColor: PropTypes.string.isRequired
}

export default AssetRow
